import { VuesticPlugin, useGlobalConfig } from 'vuestic-ui';
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { createGtm } from 'vue-gtm'
import { createI18n } from 'vue-i18n'
import './registerServiceWorker'
import { msalPlugin } from "./plugins/msalPlugin";
import { msalInstance } from "@/shared/services/auth-config";
import { AuthenticationResult, EventType } from "@azure/msal-browser";
import vuesticGlobalConfig from './services/vuestic-ui/global-config'


const i18nConfig = {
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: require('@/i18n/en.json'),
  },
}
if (process.env.VUE_APP_BUILD_VERSION) {
  // eslint-disable-next-line
  const message = `%c${'Build_information:'}`
  // eslint-disable-next-line
  console.info(
    message,
    'color: blue;', 'color: red;', 'color: blue;', 'color: red;', 'color: blue;', 'color: red;', 'color: blue;'
  )
}

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    // store.commit({account)
    msalInstance.setActiveAccount(account);
  }
});

const app = createApp({
  extends: App,
  beforeCreate() { this.$store.dispatch('user/init') }
})
app.use(store)
app.use(router)
app.use(msalPlugin, msalInstance);

if (process.env.VUE_APP_GTM_ENABLED === 'true') {
  const gtmConfig = {
    id: process.env.VUE_APP_GTM_KEY,
    debug: false,
    vueRouter: router,
  }
  app.use(createGtm(gtmConfig))
}
app.use(createI18n(i18nConfig))
app.use(VuesticPlugin, vuesticGlobalConfig)
router.isReady().then(() => {
  // Waiting for the router to be ready prevents race conditions when returning from a loginRedirect or acquireTokenRedirect
  app.mount('#app');
});

